export default "__VITE_ASSET__IJyN9Gk3__"